import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import { UseTheme } from '../../hooks/useTheme'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { getStyle } from '../helper'

export const Element = forwardRef(
  ({ elementName: Component = 'div', children, style, ...others }, ref) => {
    const typeFontSize = UseTypeFontSize()
    const theme = UseTheme()

    return (
      <Component
        ref={ref}
        style={getStyle(style, theme, typeFontSize)}
        {...others}
      >
        {children}
      </Component>
    )
  },
)

Element.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
}

Element.defaultProps = {
  style: {},
}
